import Cpf from 'cpf';

import flatpickrSetLocale from './flatpickr_set_locale';
import mountFilepicker from '../../../services/filepicker';

export function updateCv() {
  $('.candidate-cv-container .card .remove_nested_cv_fields').on('click', (event) => {
    const card = $(event.target).closest('.card');
    const filepickerContainer = card.find('.row.is-hidden');
    const filepicker = filepickerContainer.find('.filepicker');
    filepicker.empty();
    mountFilepicker(0, filepicker[0]);
    const row = $(event.target).closest('.row');
    card.find('input.destroy-field').val('1');
    row.remove();
    filepickerContainer.removeClass('is-hidden');
    $('a.parse-cv').text($('a.parse-cv').data('button'));
    $('a.parse-cv').addClass('is-disabled');
  });
}

export function selectAttachment(target = undefined) {
  const attachmentTarget = target || $('.company-documents-container .card .filepicker, .candidate-cv-container .card .filepicker');

  attachmentTarget.on('change', (event) => {
    const filePicker = $(event.target).closest('.filepicker');
    const fileName = filePicker.find('.filepicker-content .file-details .file-name').text();
    const card = filePicker.closest('.card');
    const removeLinkClass = card.closest('.company-documents-container, .candidate-documents-container').length ? 'remove_nested_fields' : 'remove_nested_cv_fields';
    const row = $(event.target).closest('.row');
    let fieldNameError;
    let fieldName;
    if (card.closest('.company-documents-container').length) {
      fieldNameError = 'company_user_info_attributes-documents_attributes';
    } else if (card.closest('.candidate-documents-container').length) {
      fieldNameError = 'professional_metadata_attributes-assets_attributes';
    } else {
      fieldNameError = 'professional_metadata_attributes-assets_attributes';
      const index = row.data('index');
      fieldName = `user_representation[professional_metadata_attributes][assets_attributes][${index}][_destroy]`;
    }
    let dataAssociation = '';
    if (card.closest('.company-documents-container').length) {
      dataAssociation = 'documents';
    } else {
      dataAssociation = 'assets';
    }
    const documentHtml = `
      ${!$(`input.destroy-field[name="${fieldName}"]`).length && fieldName && fieldName.length ? `<input type="hidden" class="hidden destroy-field" autocomplete="off" name="${fieldName}" value="0">` : ''}
      <div class="row is-vertical-centered">
        <div class="col-6">
          <span class="h3">${fileName}</span>
          <span class="error ${fieldNameError}-file-error"></span>
        </div>
        <div class="col-6 buttons-row right">
          <a class="${removeLinkClass}" data-association="${dataAssociation}" href="javascript:void(0)">
            <button class="button secondary">
              <i class="huge-icon huge-delete-02-stroke-rounded is-xsmall text-current"></i>
              Eliminar
            </button>
          </a>
        </div>
      </div>
    `;
    row.addClass('is-hidden');
    card.append(documentHtml);
    if (card.closest('.candidate-cv-container').length) {
      updateCv();
      card.find('input.destroy-field').val('0');
      $('a.parse-cv').removeClass('is-disabled');
    } else {
      row.siblings('.row.buttons-row').addClass('is-hidden');
    }
  });
}

export function addDocument() {
  $(document).on('nested:fieldAdded', (event) => {
    if (event.field.find('.filepicker').length > 0) {
      event.field.find('.filepicker').each((_, element) => {
        selectAttachment($(element));
      });
    }
  });
}

export function removeDocument() {
  $(document).on('nested:fieldRemoved:assets nested:fieldRemoved:documents', (event) => {
    event.field.find('.card .row.buttons-row input[type="hidden"]').val('1');
  });
}

export function disableRequiredFields() {
  $(document).on('nested:fieldRemoved', (event) => {
    event.field.find('input, select').filter('[required="required"]').prop('disabled', true);
  });
}

const validFields = {
  email: true,
  phone: true,
  personalIdentifier: true,
  birthDate: true,
};

const disableForm = (element) => {
  const disable = Object.values(validFields).some((value) => !value);
  element.closest('form').find('input[type="submit"]').prop('disabled', disable);
};

const dniRegex = /^\d{8}-[a-zA-Z]$/;
const dniNieLetterValues = 'TRWAGMYFPDXBNJZSQVHLCKET';

const dniValidation = (value) => {
  if (dniRegex.test(value)) {
    const splittedDni = value.split('-');
    const dniNumber = splittedDni[0];
    const dniCharValue = splittedDni[1];
    const validLetter = dniNieLetterValues.substring((dniNumber % 23), (dniNumber % 23) + 1);
    if (validLetter !== dniCharValue.toUpperCase()) {
      return 'dni-letter';
    }
    return undefined;
  }
  return (value ? 'dni-format' : undefined);
};

const nieRegex = /^[XYZ]{1}[0-9]{7}-[a-zA-Z]$/;

const nieValidation = (value) => {
  if (nieRegex.test(value)) {
    const splittedNie = value.split('-');
    let nieNumber = splittedNie[0];
    const nieCharValue = splittedNie[1];
    nieNumber = nieNumber.replace(/^[X]/, '0').replace(/^[Y]/, '1').replace(/^[Z]/, '2');
    const validLetter = dniNieLetterValues.substring((nieNumber % 23), (nieNumber % 23) + 1);
    if (validLetter !== nieCharValue.toUpperCase()) {
      return 'nie-letter';
    }
    return undefined;
  }
  return (value ? 'nie-format' : undefined);
};

const rutCodeValidation = (value) => {
  const splittedRut = value.split('-');
  let rutNumber = splittedRut[0];
  const rutDigValue = (splittedRut[1] === 'k' ? 'K' : splittedRut[1]);
  let M = 0;
  let S = 1;

  for (; rutNumber; rutNumber = Math.floor(rutNumber / 10)) {
    S = (S + ((rutNumber % 10) * (9 - (M % 6)))) % 11;
    M += 1;
  }

  const validDigValue = S ? S - 1 : 'K';

  return (validDigValue.toString() === rutDigValue
    ? undefined
    : 'rut-character');
};

const rutRegex = /^[0-9]{8}[-|‐]{1}[0-9kK]{1}$/;

const rutFormat = (value) => (rutRegex.test(value) ? undefined : 'rut-format');

const rutValidation = (value) => (rutCodeValidation(value) || rutFormat(value));

const cpfBrValidation = (value) => {
  try {
    const formattedCpf = Cpf.format(value);

    return (Cpf.isValid(formattedCpf) ? undefined : 'cpf-br-character');
  } catch (error) {
    return 'cpf-br-format';
  }
};

const validatePersonalIdentifier = () => {
  $('select.personal-identifier-type, input.personal-identifier').on('change', () => {
    const personalIdentifierType = $('select.personal-identifier-type').val();
    const personalIdentifier = $('input.personal-identifier').val();
    let errorCode;

    if (personalIdentifier) {
      if (personalIdentifierType === 'dni_es') {
        errorCode = dniValidation(personalIdentifier);
      } else if (personalIdentifierType === 'nie_es') {
        errorCode = nieValidation(personalIdentifier);
      } else if (personalIdentifierType === 'rut_cl') {
        errorCode = rutValidation(personalIdentifier);
      } else if (personalIdentifierType === 'cpf_br') {
        errorCode = cpfBrValidation(personalIdentifier);
      }
    }

    if (errorCode) {
      validFields.personalIdentifier = false;
      disableForm($('input.personal-identifier'));
      $('input.personal-identifier').closest('.control-group').addClass('error');
      $('span.user_metadata_attributes-dni-error').text($('span.user_metadata_attributes-dni-error').data(`invalid-${errorCode}-message`));
    } else {
      validFields.personalIdentifier = true;
      disableForm($('input.personal-identifier'));
      $('input.personal-identifier').closest('.control-group').removeClass('error');
      $('span.user_metadata_attributes-dni-error').text('');
    }
  });
};

const emailRegex = /^[A-z0-9._%+-]+@[A-z0-9.-]+\.[A-z]{2,}$/;

const validateEmail = () => {
  $('input[type="email"]').on('change', (event) => {
    const email = event.target.value;
    const errorElement = $('span.email-error');
    if (email && !emailRegex.test(email)) {
      validFields.email = false;
      disableForm($(event.target));
      $(event.target).closest('.control-group').addClass('error');
      errorElement.text(errorElement.data('invalid-format-message'));
    } else if (errorElement.text() === errorElement.data('invalid-format-message')) {
      validFields.email = true;
      disableForm($(event.target));
      $(event.target).closest('.control-group').removeClass('error');
      errorElement.text('');
    }
  });
};

const phoneRegex = /^(\+\(?[0-9]{1,3}\)? ?)?[0-9 .-]{7,}[0-9]$/;

const validatePhone = () => {
  $('input[type="tel"]').on('change', (event) => {
    const phone = event.target.value;
    const errorElement = $('span.professional_metadata_attributes-phone-error');
    if (phone && !phoneRegex.test(phone)) {
      validFields.phone = false;
      disableForm($(event.target));
      $(event.target).closest('.control-group').addClass('error');
      errorElement.text(errorElement.data('invalid-format-message'));
    } else if (errorElement.text() === errorElement.data('invalid-format-message')) {
      validFields.phone = true;
      disableForm($(event.target));
      $(event.target).closest('.control-group').removeClass('error');
      errorElement.text('');
    }
  });
};

const validateDate = (value) => {
  const daysMonths = {
    1: 31,
    2: 28,
    3: 31,
    4: 30,
    5: 31,
    6: 30,
    7: 31,
    8: 31,
    9: 30,
    10: 31,
    11: 30,
    12: 31,
  };

  let values = '';
  if (value instanceof Object) {
    values = value.format('DD-MM-YYYY').split('/');
  } else {
    values = value.split('/');
  }

  // Check leap-year
  if ((((values[2] % 100) !== 0) && ((values[2] % 4) === 0)) || ((values[2] % 400) === 0)) {
    daysMonths[0] = 29;
  }

  return (values[0] > daysMonths[values[1]])
    ? 'date'
    : undefined;
};

const validateAge = (value) => {
  const parts = value.split('/');
  const now = new Date();
  const birthday = new Date(now.getFullYear(), parts[1] - 1, parts[0]);
  let years = now.getFullYear() - parts[2];
  if (now < birthday) years -= 1;

  return (years < 16)
    ? 'age'
    : undefined;
};

const validateBirthDate = () => {
  $('input#user_representation_user_metadata_attributes_birth_date').on('change', (event) => {
    const birthDate = event.target.value;
    const errorCode = (birthDate ? (validateDate(birthDate) || validateAge(birthDate)) : undefined);

    const errorElement = $('span.user_metadata_attributes-birht_date-error');
    if (errorCode) {
      validFields.birthDate = false;
      disableForm($(event.target));
      $(event.target).closest('.control-group').addClass('error');
      errorElement.text(errorElement.data(`invalid-${errorCode}-message`));
    } else {
      validFields.birthDate = true;
      disableForm($(event.target));
      $(event.target).closest('.control-group').removeClass('error');
      errorElement.text('');
    }
  });
};

export function validations() {
  validatePersonalIdentifier();
  validateEmail();
  validatePhone();
  validateBirthDate();
}

const waitForCVParserChannel = () => new Promise(resolve => {
  const check = () => {
    if (window.CVParserChannelConnected) {
      resolve();
    } else {
      setTimeout(check, 100);
    }
  };
  check();
});

const getCompanySlug = () => document.querySelector('meta[name="current-company-id"]').content;

const handleCandidateFileSelection = (file) => {
  if (!file) return;

  const companySlug = getCompanySlug();

  if (!companySlug) {
    return;
  }

  waitForCVParserChannel().then(() => {
    const formData = new FormData();
    formData.append('candidate[file]', file);

    const endpoint = `/trabajar/${companySlug}/cv_parser`;

    $.ajax({
      url: endpoint,
      method: 'POST',
      dataType: 'script',
      data: formData,
      processData: false,
      contentType: false,
    });
  });
};

export function parseCv() {
  $('a.parse-cv').on('click', (event) => {
    event.preventDefault();
    if ($('#floating-alerts .alert.error').length) {
      $('#floating-alerts .alert.error').addClass('is-hidden');
    }
    const file = $('.filepicker.candidate-curriculum input[type="file"]')[0].files[0];
    handleCandidateFileSelection(file);
    $.rails.enableElement($('a.parse-cv'));
    $('a.parse-cv').addClass('is-disabled');
  });
}

export function successCvParser(data) {
  $('.candidate-form-body').html(data.html);
}

export function errorCvParser() {
  if ($('#floating-alerts .alert.error').length) {
    $('#floating-alerts .alert.error').removeClass('is-hidden');
  } else {
    const alertHtml = `<div data-alert="${$('.error-alert-container').data('alert-message')}" data-alert-opts='{"timeout": false, "floating": true, "size": "medium", "type": "error"}'></div>`;
    $('.error-alert-container').html(alertHtml);
    window.Bizneo.dom.update('.error-alert-container');
  }
  $.rails.enableElement($('a.parse-cv'));
  $('a.parse-cv').removeClass('is-disabled');
  $('a.parse-cv').text($('a.parse-cv').data('button'));
}

const defaultOptions = {
  dateFormat: 'd/m/Y',
  animate: false,
  allowInput: true,
  disableMobile: true,
};

export async function initDatepicker() {
  if ($('input.datetime').length) {
    const { default: flatpickr } = await import(/* webpackChunkName: "flatpickr" */ 'flatpickr');
    await flatpickrSetLocale(flatpickr);

    $('input.datetime').each((_index, element) => {
      flatpickr(element, defaultOptions);
    });
  }
}

export async function fileFromUrl(uploadedFile) {
  try {
    const response = await fetch(uploadedFile.url);
    if (!response.ok) return null;
    const blob = await response.blob();
    const file = new File([blob], uploadedFile.original_filename, {
      type: uploadedFile.content_type,
      lastModified: new Date().getTime(),
    });
    return file;
  } catch (error) {
    return null;
  }
}

export async function initFilepicker(file) {
  const element = $('.filepicker.filepicker-async');
  const fp = await mountFilepicker(null, element[0]);

  if (file) {
    fp.initializeInputWithFiles([file]);
    $('a.parse-cv').text($('a.parse-cv').data('processed_button'));
    window.Bizneo.dom.update('.filepicker.filepicker-async');
  }
}
